module.exports = __webpack_public_path__ + "img/unlike.972940d6.svg";